import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Radio from '@mui/material/Radio';
import Divider from "@material-ui/core/Divider";
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import { getThemeProps } from "@material-ui/styles";
import { Search } from "@chatscope/chat-ui-kit-react";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function SelectedListItem(props) {
  const classes = useStyles();
  const [selectedIndex, setSelectedIndex] = React.useState();
  const [lists, setLists] = React.useState(props.lists);

  const handleListItemClick = (event, index, listitem) => {
    let selectedEnvs = props.selectedEnv
    let selectedEnv  = selectedEnvs[props.index]
    selectedEnv['list'] = listitem     
    selectedEnvs[props.index] = selectedEnv
    setSelectedIndex(index);
    props.setSelectedList(listitem)
    props.setSelectedEnv(selectedEnvs)
  };

  const filterList = search => {
    setLists(props.lists.filter(e => e.name.toLowerCase().includes(search.toLowerCase())))
  }

  return (
    <div className={classes.root}>
      <input
        style={{width: '100%'}}
        placeholder="Search list"
        onKeyUp={event => filterList(event.target.value)}
      />
      <List aria-label="secondary mailbox folder">
        {lists &&
          lists.map((listitem, index) => {
            return (
              <ListItem
                key={listitem.id}
                button
                selected={selectedIndex === index}
                onClick={(event) => handleListItemClick(event, index, listitem)}
              >
                <ListItemIcon>
                    <Radio
                      edge="start"
                      checked={selectedIndex === index}
                      tabIndex={-1}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText 
                    primary={listitem.name}
                  />
              </ListItem>
            );
          })}
      </List>
    </div>
  );
}
